<template>
  <div class="d-flex justify-between filters my-2">
    <div class="flex pr-5">
      <v-text-field
        label="Name"
        dense
        outlined
        hide-details
        v-model="name"
        @focus="name = ''"
        @blur="name == '' || name == null ? (name = ' ') : ''"
        @change="$emit('update:name', $event)"
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="flex pr-5">
      <v-text-field
        label="Postcode"
        dense
        outlined
        hide-details
        v-model="postcode"
        @focus="postcode = ''"
        @blur="postcode == '' || postcode == null ? (postcode = ' ') : ''"
        @change="$emit('update:postcode', $event)"
        append-icon="shopping_basket"
      >
      </v-text-field>
    </div>
    <div class="flex pr-5">
      <v-select
        :items="approveItems"
        v-model="approved"
        @change="$emit('update:approved', $event)"
        label="Approved"
        hide-details
        dense
        outlined
        append-icon="apartment"
      ></v-select>
    </div>
    <div class="flex pr-5">
      <v-select
        :items="activeItems"
        v-model="active"
        hide-details
        @change="$emit('update:active', $event)"
        label="Active"
        dense
        append-icon="tab"
        outlined
      ></v-select>
    </div>
    <div class="flex pr-5">
      <v-select
        :items="actions"
        label="Batch Action"
        append-icon="more_vert"
        hide-details
        :disabled="!action"
        class="action_button"
        :menu-props="{ bottom: true, offsetY: true }"
        dense
        outlined
      >
        <template v-slot:append-item>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item-group>
              <v-list-item class="pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    Delete
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </template>
      </v-select>
    </div>
    <div>
      <v-btn block color="primary" @click="$emit('apply')">Apply filters</v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    postcode: {
      type: String,
      default: null
    },
    approved: {
      type: Boolean,
      default: null
    },
    active: {
      type: Boolean,
      default: null
    },
    action: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      approveItems: [
        {
          text: "",
          value: null
        },
        {
          text: "true",
          value: 1
        },
        {
          text: "false",
          value: 0
        }
      ],
      activeItems: [
        {
          text: "",
          value: null
        },
        {
          text: "true",
          value: 1
        },
        {
          text: "false",
          value: 0
        }
      ],
      actions: []
    };
  }
};
</script>
